/**
 * BugzId 80596
 *
 * Implements a form submission interceptor that aggregates multiple clicks of
 * the submit button into one every 500ms. Subsequently the form is disabled and
 * its submit method called.
 *
 * The fields can be enabled once the form submission is handled by the
 * implementing view and this behavior class is notified.
 *
 * Form View Requirements:
 *
 * 1. Form fields must be wrapped in a <fieldset>.
 * 2. Submit button must be a button[type=button] with the .submit className.
 * 3. Upon API success or failure, the form must trigger this behavior's
 *   FormSubmissionComplete method in order to enable the form fields.
 * 4. Form must handle the submit event.
 *
 */

import Marionette from "backbone.marionette";

const DEBOUNCE_DELAY_MS = 500;

class FormSubmission extends Marionette.Behavior {
  ui() {
    return {
      fieldset: ">fieldset",
      submitBtn: "button.submit",
    };
  }

  events() {
    return {
      // debounces clicks on submit button
      "click @ui.submitBtn": _.debounce(this.onClick, DEBOUNCE_DELAY_MS),
    };
  }

  onClick(e) {
    e.preventDefault();

    // disable form > fieldset
    this.ui.fieldset.attr("disabled", true);

    // call the form's submit method
    this.view.$el.submit();
  }

  /**
   * Custom method triggered by the implemeting view when a model sync
   * completes, whether it succeeded or not.
   */
  onFormSubmissionComplete() {
    // enable form > fieldset
    this.ui.fieldset.attr("disabled", false);
  }
}

export { FormSubmission as default };
